import { Alert } from "../../../lib/alert.web";

import {
  getCvDeleteConfirmationCopy,
  type CvDeleteTarget,
} from "./delete-confirmation-copy";

type Translator = (key: string, options?: Record<string, unknown>) => string;

interface DeleteConfirmationOptions {
  title?: string;
  message?: string;
}

export async function confirmDeleteCvItem(
  t: Translator,
  target: CvDeleteTarget,
  onConfirm: () => void | Promise<void>,
  options: DeleteConfirmationOptions = {},
) {
  const copy = getCvDeleteConfirmationCopy(t, target);

  return new Promise<void>((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      resolve();
    };

    Alert.alert(
      options.title ?? copy.title,
      options.message ?? copy.message,
      [
        {
          text: t("cv.edit.cancel"),
          style: "cancel",
          onPress: finish,
        },
        {
          text: t("cv.edit.delete"),
          style: "destructive",
          onPress: async () => {
            await onConfirm();
            finish();
          },
        },
      ],
      { cancelable: true, onDismiss: finish },
    );
  });
}
